<template>
    <div class="li-wrapper">
        <div class="chart-item">
            <p>混凝土</p>
            <div class="total-wrapper">
                <div class="total-item">
                    本月毛利率(%):<span>{{ hntTotal.bymlv }}</span>
                </div>
                <div class="total-item">
                    平均毛利率(%):<span>{{ hntTotal.bnmlv }}</span>
                </div>
            </div>
            <div id="hntChart" class="chart-wrapper hntChart"></div>
        </div>
        <div class="chart-item">
            <p>砂浆</p>
            <div class="total-wrapper">
                <div class="total-item">
                    本月毛利率(%):<span>{{ sjTotal.bymlv }}</span>
                </div>
                <div class="total-item">
                    平均毛利率(%):<span>{{ sjTotal.bnmlv }}</span>
                </div>
            </div>
            <div id="sjChart" class="chart-wrapper sjChart"></div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data() {
        return {
            hntData: [],
            sjData: [],
            hntTotal: {},
            sjTotal: {},
            Year: '',
            Month: '',
        };
    },
    created() {
        this.Year = new Date().getFullYear();
        this.Month = new Date().getMonth() + 1;
    },
    mounted() {
        this.getStatistics(0);
        this.getStatistics(1);
        this.getTotal(0);
        this.getTotal(1);
    },
    methods: {
        getTotal(type) {
            this.$axios
                .get('/interfaceApi/report/largescreen/xslrcp/tj/' + this.Year + '/' + this.Month + '/' + type)
                .then(res => {
                    if (type === 0) {
                        this.hntTotal = res;
                    } else {
                        this.sjTotal = res;
                    }

                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        getStatistics(type) {
            this.$axios
                .get('/interfaceApi/report/largescreen/xslrcp/' + this.Year + '/' + this.Month + '/' + type)
                .then(res => {
                    if (type === 0) {
                        this.hntData = res;
                        this.hntChart();
                    } else {
                        this.sjData = res;
                        this.sjChart();
                    }
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        sjChart() {
            const myChart = this.$echarts.init(document.getElementById('sjChart'));
            const xdata = [];
            const data = [];
            this.sjData.forEach(item => {
                xdata.push(item.yf + '月');
                data.push(item.mlv);
            });
            const option = {
                grid: {
                    left: '10%',
                    top: '20%',
                    bottom: '12%',
                    right: '0%',
                },
                legend: {
                    left: 'right',
                    selectedMode: false,
                    top: '20',
                    textStyle: {
                        color: '#ccc',
                    },
                },
                xAxis: {
                    data: xdata,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 4,
                    name: '(%)',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: [{
                    name: '每月毛利率',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#F98F48',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}%',
                        align: 'center',
                    },
                    lineStyle: {
                        normal: {
                            color: '#F98F48', // 线条颜色
                        },
                    },
                    itemStyle: {
                        color: '#F98F48',
                        borderColor: '#F98F48',
                    },
                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(249,143,72,1)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(249,143,72,0.2)',
                            },
                            ], false),
                        },
                    },
                    data: data,
                    z: 10,
                }],
            };
            myChart.setOption(option);
        },
        hntChart() {
            const myChart = this.$echarts.init(document.getElementById('hntChart'));
            const xdata = [];
            const data = [];
            this.hntData.forEach(item => {
                xdata.push(item.yf + '月');
                data.push(item.mlv);
            });
            const option = {
                grid: {
                    left: '10%',
                    top: '20%',
                    bottom: '12%',
                    right: '0%',
                },
                legend: {
                    left: 'right',
                    selectedMode: false,
                    top: '20',
                    textStyle: {
                        color: '#ccc',
                    },
                },
                xAxis: {
                    data: xdata,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 4,
                    name: '(%)',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: [{
                    name: '每月毛利率',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#56AC9D',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}%',
                        width: 18,
                        height: 22,
                        align: 'center',
                        lineHeight: 20,
                    },
                    lineStyle: {
                        normal: {
                            color: '#56AC9D', // 线条颜色
                        },
                    },
                    itemStyle: {
                        color: '#56AC9D',
                        borderColor: '#56AC9D',
                    },
                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(86, 172, 157, 1)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(86, 172, 157, 0.2)',
                            },
                            ], false),
                        },
                    },
                    data: data,
                    z: 10,
                }],
            };
            myChart.setOption(option);
        },
    },
};
</script>

<style lang="stylus">
    .li-wrapper
        // margin-top 20rpx
        .chart-item
            padding 15rpx
            background #ffffff
            &:last-child
                margin-top 15rpx
            p
                font-size 16rpx
                font-weight 600
                color rgba(51,51,51,1)
                line-height 36px
            .total-wrapper
                display flex
                justify-content space-between
                .total-item
                    width 150rpx
                    height 30rpx
                    border 2rpx solid rgba(234,234,234,1)
                    font-size 10rpx
                    line-height 26rpx
                    text-align center
                    span
                        font-size 14rpx
                        line-height 26rpx
                    &:first-child
                        span
                            color #4486D5
                    &:last-child
                        span
                            color #F8924A
            .chart-wrapper
                height 200rpx
                width 100%


</style>